/**
 * @generated SignedSource<<5d79242ea0808a64c27d01283083f256>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BulkOperationsWrapper_ViewSettings$data = {
  readonly viewSettings: {
    readonly groupByConfig: {
      readonly groupByField: {
        readonly fieldId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly hideDone: boolean | null | undefined;
    readonly isHierarchyEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "BulkOperationsWrapper_ViewSettings";
};
export type BulkOperationsWrapper_ViewSettings$key = {
  readonly " $data"?: BulkOperationsWrapper_ViewSettings$data;
  readonly " $fragmentSpreads": FragmentRefs<"BulkOperationsWrapper_ViewSettings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "BulkOperationsWrapper_ViewSettings",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "groupBy",
          "variableName": "groupBy"
        },
        {
          "kind": "Variable",
          "name": "issueSearchInput",
          "variableName": "issueSearchInput"
        },
        {
          "kind": "Variable",
          "name": "settings",
          "variableName": "settings"
        },
        {
          "kind": "Variable",
          "name": "staticViewInput",
          "variableName": "staticViewInput"
        }
      ],
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isHierarchyEnabled"
        },
        {
          "kind": "ScalarField",
          "name": "hideDone"
        },
        {
          "concreteType": "JiraSpreadsheetGroupByConfig",
          "kind": "LinkedField",
          "name": "groupByConfig",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraField",
              "kind": "LinkedField",
              "name": "groupByField",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldId"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "36f1477c999f2db53447c32a5847cb2d";

export default node;
